<template>
    <div class=" page no-top-bar">

        <div class=" h-screen">
            <TopBarDetail
                :title="'คำถามที่พบบ่อย'"
                :isShowBack="true"
                :isShowFavorite="false"
                :isShowShare="false"
                @clickBack="clickBack()"
            ></TopBarDetail>
            <div class=" h-full">
                <iframe
                    title=""
                    class=" h-full w-full"
                    :src="urlfaq()"
                ></iframe>
            </div>
        </div>

    </div>
</template>
<script>

import ConfigManager from "@/config/ConfigManager.js";
import Locale from "@/helper/locale/Locale.js";
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';

export default {
    name: 'Faq',
    components: {
        TopBarDetail,
    },
    created: function() {
        this.tracking.screenName('faq');
        this.tracking.event('faq', 'view_faq');
    },
    methods: {
        clickBack: function() {
            this.$router.back();
        },

        urlfaq: function() {
            let localecode = Locale.getLocaleCode()

            return ConfigManager.getMiscUrl() + '/seg/faq.html' + '?locale=' + localecode;

        }
    },
}
</script>
